<!--
 * @Author: DY
 * @Date: 2020-07-22 11:12:03
 * @LastEditTime: 2022-11-02 16:15:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\statisticalAnalysis\SalesReport.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="SalesReport">
            <van-nav-bar
                title="销售日报表"
                left-text="销售日报"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <div class="top-wrapper">
                    <div class="select-wrapper">
                        <div class="select-item">
                            <div @click="startTimePicker = true">
                                <span>{{ startTimeValue }}</span>
                                <i class="iconfont iconxiala"></i>
                            </div>
                        </div>
                        <div
                            class="select-item"
                            @click="showPicker = true"
                        >
                            <span>{{ StationName }}</span>
                            <i class="iconfont iconxiala"></i>
                        </div>
                    </div>
                </div>
                <div class="statistics-head">
                    <van-tabs swipeable animated>
                        <template v-for="(item,index) in totalData">
                            <van-tab :key="index" :title="item.name">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <template v-if="item.fhfl > 10000">
                                                    <h5 style="color:#5588F1;">
                                                        {{ numberConvert(item.fhfl) }}
                                                    </h5>
                                                    <p>发货<br>方量(万方)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#5588F1;">
                                                        {{ item.fhfl }}
                                                    </h5>
                                                    <p>发货<br>方量(方)</p>
                                                </template>
                                            </td>
                                            <td>
                                                <template v-if="item.qsfl > 10000">
                                                    <h5 style="color:#5588F1;">
                                                        {{ numberConvert(item.qsfl) }}
                                                    </h5>
                                                    <p>签收<br>方量(万方)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#5588F1;">
                                                        {{ item.qsfl }}
                                                    </h5>
                                                    <p>签收<br>方量(方)</p>
                                                </template>
                                            </td>
                                            <td>
                                                <template v-if="item.tzhqsfl > 10000">
                                                    <h5 style="color:#5588F1;">
                                                        {{ numberConvert(item.tzhqsfl) }}
                                                    </h5>
                                                    <p>调整后签收<br>方量(万方)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#5588F1;">
                                                        {{ item.tzhqsfl }}
                                                    </h5>
                                                    <p>调整后签收<br>方量(方)</p>
                                                </template>
                                            </td>
                                            <td v-if="$store.state.versionMark == 2">
                                                <template v-if="item.tje > 10000">
                                                    <h5 style="color:#FA8436;">
                                                        {{ numberConvert(item.tje) }}
                                                    </h5>
                                                    <p>累计砼<br>金额(万元)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#FA8436;">
                                                        {{ item.tje }}
                                                    </h5>
                                                    <p>累计砼<br>金额(元)</p>
                                                </template>
                                            </td>
                                            <td>
                                                <template v-if="item.bsfl > 10000">
                                                    <h5 style="color:#21BDCC;">
                                                        {{ numberConvert(item.bsfl) }}
                                                    </h5>
                                                    <p>泵送<br>方量(万方)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#21BDCC;">
                                                        {{ item.bsfl }}
                                                    </h5>
                                                    <p>泵送<br>方量(方)</p>
                                                </template>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <template v-if="item.tzhbsfl > 10000">
                                                    <h5 style="color:#21BDCC;">
                                                        {{ numberConvert(item.tzhbsfl) }}
                                                    </h5>
                                                    <p>调整后泵送<br>方量(万方)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#21BDCC;">
                                                        {{ item.tzhbsfl }}
                                                    </h5>
                                                    <p>调整后泵送<br>方量(方)</p>
                                                </template>
                                            </td>
                                            <td v-if="$store.state.versionMark == 2">
                                                <template v-if="item.bsje > 10000">
                                                    <h5 style="color:#FFB729;">
                                                        {{ numberConvert(item.bsje) }}
                                                    </h5>
                                                    <p>累计泵送<br>金额(万元)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#FFB729;">
                                                        {{ item.bsje }}
                                                    </h5>
                                                    <p>累计泵送<br>金额(元)</p>
                                                </template>
                                            </td>
                                            <td v-if="$store.state.versionMark == 2">
                                                <template v-if="item.sjje > 10000">
                                                    <h5 style="color:#5588F1;">
                                                        {{ numberConvert(item.sjje) }}
                                                    </h5>
                                                    <p>砂浆费用<br>金额(万元)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#5588F1;">
                                                        {{ item.sjje }}
                                                    </h5>
                                                    <p>砂浆费用<br>金额(元)</p>
                                                </template>
                                            </td>
                                            <td v-if="$store.state.versionMark == 2">
                                                <template v-if="item.hjje > 10000">
                                                    <h5 style="color:#FFB729;">
                                                        {{ numberConvert(item.hjje) }}
                                                    </h5>
                                                    <p>金额合计<br>金额(万元)</p>
                                                </template>
                                                <template v-else>
                                                    <h5 style="color:#FFB729;">
                                                        {{ item.hjje }}
                                                    </h5>
                                                    <p>金额合计<br>金额(元)</p>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </van-tab>
                        </template>
                    </van-tabs>
                </div>
                <ul class="list">
                    <template v-for="(item, index) in listData">
                        <li :key="index">
                            <div class="engineeringInfo">
                                <h4 class="engineeringInfo_header">
                                    <span class="headerName">任务单号:{{ item.rwdh }}</span>
                                </h4>
                                <div class="engineeringInfo_content">
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                        <span>工程名称：{{ item.gcmc }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                        <span>客户名称：{{ item.khmc }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                        <span>施工部位：{{ item.sgbw }}</span>
                                    </p>
                                    <div class="newStyle">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                            <span>产品标号：{{ item.cpbh }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_10.png" alt="">
                                            <span>运输里程：{{ item.yslc }}</span>
                                        </p>
                                    </div>
                                    <div class="newStyle">
                                        <p>
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            <span>发货方量：{{ item.fhfl }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_30.png" alt="">
                                            <span>签收方量：{{ item.qsfl }}</span>
                                        </p>
                                    </div>
                                    <p>
                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                        <span>调整后签收方量：{{ item.tzhqsfl }}</span>
                                    </p>
                                    <p v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>砼单价：{{ item.tdj }}元/方</span>
                                    </p>
                                    <p v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>调整后砼单价：{{ item.tzhtdj }}元/方</span>
                                    </p>
                                    <!-- <p>
                                    <img src="@/assets/images/icons/icon_26.png" alt="">
                                    <span>累计砼金额：{{ item.rwdh }}元</span>
                                </p> -->
                                    <p>
                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                        <span>泵送方量：{{ item.bsfl }}方</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                        <span>调整后泵送方量：{{ item.tzhbsfl }}方</span>
                                    </p>
                                    <p v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>泵送单价：{{ item.bsje }}元/方</span>
                                    </p>
                                    <!-- <p>
                                    <img src="@/assets/images/icons/icon_26.png" alt="">
                                    <span>累计泵送金额：{{ item.rwdh }}元</span>
                                </p> -->
                                    <!-- <div class="newStyle">
                                    <p>
                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                        <span>补方：{{ item.rwdh }}方</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>补方金额：{{ item.rwdh }}元</span>
                                    </p>
                                </div> -->
                                    <div class="newStyle">
                                        <p>
                                            <img src="@/assets/images/icons/my_9.png" alt="">
                                            <span>泵送/自卸：{{ item.jzfs }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                            <span>发货单：{{ item.fhd }}</span>
                                        </p>
                                    </div>
                                    <p v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>砂浆费用：{{ item.sjje }}元/方</span>
                                    </p>
                                    <p v-if="$store.state.versionMark == 2">
                                        <img src="@/assets/images/icons/icon_26.png" alt="">
                                        <span>合计金额：{{ item.hjje }}元</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                        <span>客户联系人：{{ item.ywy }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_4.png" alt="">
                                        <span>备注：{{ item.bz }}</span>
                                    </p>
                                    <span class="state iconfont iconjiaobiao">
                                        <i>{{ item.zt }}</i>
                                    </span>
                                </div>
                                <!-- <button class="telephone"></button> -->
                            </div>
                        </li>
                    </template>
                </ul>
            </section>
            <!-- 选择场站 -->
            <van-popup
                v-model="showPicker"
                position="bottom"
            >
                <van-picker
                    show-toolbar
                    :columns="columns"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                ></van-picker>
            </van-popup>
            <!-- 选择时间-->
            <van-popup
                v-model="startTimePicker"
                position="bottom"
                :overlay="true"
            >
                <van-datetime-picker
                    v-model="startCurrentDate"
                    type="date"
                    title="选择年月日"
                    @confirm="startConfirmData"
                    @cancel="startTimePicker = false"
                ></van-datetime-picker>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 销售如报表
    name: 'sales-report',
    components: {},
    props: {},
    data() {
        return {
            // 开始时间text
            startTimeValue: '',
            // 时间弹出层
            startTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(new Date().getTime() - 3600 * 1000 * 24),
            // 场站名称
            StationName: '华能站',
            // 场站id
            StationId: '',
            // 场站数据集
            columns: [],
            // 场站弹出层状态
            showPicker: false,
            // 场站初始数据
            StationData: [
                {
                    station_id: '',
                    name: '全部',
                },
            ],
            // 合计数据
            totalData: {},
            // 列表数据
            listData: [],
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
    },
    computed: {},
    watch: {
        startTimeValue(newVal) {
            if (newVal !== '') {
                if (this.StationData.length < 2) {
                    // 获取场站
                    this.getStationList();
                } else {
                    this.salesanalysisDay();
                }
            }
        },
        StationId() {
            this.salesanalysisDay();
        },
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取企业下所有场站
        async getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
                this.salesanalysisDay();
            }
        },
        // 确认选择场站
        onConfirm(val, index) {
            this.showPicker = false;
            this.StationName = this.StationData[index].name;
            this.StationId = this.StationData[index].station_id;
        },
        // 确认选择时间
        startConfirmData(val) {
            this.startTimeValue = this.formatDate(val);
            this.startTimePicker = false;
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 超过10000数字转换
        numberConvert(data) {
            return Number((data / 10000).toString().match(/^\d+(?:\.\d{0,2})?/));
        },
        // 获取报表数据
        salesanalysisDay() {
            this.$axios
                .get(`/interfaceApi/report/salesanalysis/xsqk/day?date=${this.startTimeValue}&station_id=${this.StationId}`)
                .then(res => {
                    this.totalData = res.total;
                    this.listData = res.list;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
    },
};
</script>
<style lang="stylus">
.SalesReport
    height 100%
    section
        height calc(100% - 44rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        background #F0F0F0
        .top-wrapper
            padding 15rpx
            padding-bottom 0
            .select-wrapper
                height 45rpx
                box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
                border-radius 8px
                display flex
                background #ffffff
                .select-item
                    flex 1
                    text-align center
                    span
                        font-size 14rpx
                        font-weight 400
                        line-height 45rpx
                    i
                        color #979EA7
                    &:last-child
                        position relative
                        &:before
                            content ''
                            height 20rpx
                            position absolute
                            left 0
                            top 50%
                            margin-top -10rpx
                            border-left 3rpx solid #D7D7D7
                        span
                            color #3495FB
                            padding-left 20rpx
                    &:first-child
                        display flex
                        div
                            flex 1
                        p
                            line-height 45rpx
                            color #979EA7
                            font-weight 600
        .statistics-head
            height 151rpx
            margin 15rpx
            background rgba(255,255,255,1)
            box-shadow 1px 1px 2px 0px rgba(0,0,0,0.2)
            border-radius 4px
            overflow hidden
            .van-tabs
                height 100%
                .van-tabs__wrap
                    height 30rpx
                    .van-tab__text
                        height 30rpx
                        line-height 30rpx
                .van-tabs__line
                    display none
                .van-tab
                    line-height 30rpx
                    &.van-tab--active
                        background-color #3495FB
                        color #fff
                .van-tabs__content
                    height calc(100% - 30rpx)
                    .van-tab__pane
                        height 100%
                        padding 5rpx
                        table
                            width 100%
                            height 100%
                            td
                                width 20%
                            h5,p
                                text-align center
                            p
                                font-size 10rpx
                                line-height 15rpx
                                color #979EA7
                                font-weight 400
                            h5
                                font-size 16rpx
        .list
            background #F0F0F0
            padding 0 15rpx
            padding-bottom 0
            li
                width 100%
                background #fff
                overflow hidden
                margin-bottom 15rpx
                position relative
                &:first-child
                    margin-top 15rpx
                strong
                    color #d60110
                    position absolute
                    top 46rpx
                    right 15rpx
                .engineeringInfo
                    position relative
                    padding 15rpx
                    img,span
                        float left
                        height 16rpx
                        line-height 16rpx
                    img
                        width 16rpx
                        margin-right 12rpx
                    h4,p
                        overflow hidden
                    h4
                        margin-bottom 14rpx
                        span
                            font-size 18rpx
                            height 20rpx
                            line-height 20rpx
                            color #061F3E
                            &:before
                                font-size 20rpx
                                margin-right 10rpx
                                color #0189FC
                    p
                        margin-bottom 14rpx
                        span
                            display inline-block
                            width calc(100% - 40rpx)
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 14rpx
                            color #666666
                    .state
                        position absolute
                        top 0
                        right 0
                        font-weight 400
                        width 40rpx
                        height 40rpx
                        &:before
                            font-size 40rpx
                            line-height 40rpx
                            color #04A2B9
                            position absolute
                            top 0px
                            right 0
                        i
                            position absolute
                            width 40rpx
                            text-align center
                            font-size 10rpx
                            color #FFFFFF
                            transform rotate(45deg)
                            top 7rpx
                            left 7rpx

                    .telephone
                        width 25rpx
                        height 25rpx
                        background url(./../../../assets/images/clueManagement/phone@2x.png)
                        background-size 100% 100%
                        border none
                        position absolute
                        right 15rpx
                        bottom 25rpx
                    .newStyle
                        overflow hidden
                        p
                            width 50%
                            float left
                .btns
                    padding 0 6rpx
                    text-align center
                    div
                        border 1px solid #D7D7D7
                        border-radius 4rpx
                        background #fff
                        height 32rpx
                        line-height 32rpx
                        text-align center
                        display inline-block
                        margin 0 25rpx
                        font-size 14rpx
                        color #333333
                        width calc((100% - 36rpx)/3)
                        img
                            width 16rpx
                            vertical-align middle
                            margin-top -4rpx
                &.item-102-LS1
                    h4
                        span
                            &:before
                                color #191990
                    .state
                        &:before
                            color #191990
                &.item-102-LS2
                    h4
                        span
                            &:before
                                color #FF6600
                    .state
                        &:before
                            color #FF6600
                &.item-102-XX0
                    h4
                        span
                            &:before
                                color #00A84B
                    .state
                        &:before
                            color #00A84B
                &.item-102-ZS0
                    h4
                        span
                            &:before
                                color #E60000
                    .state
                        &:before
                            color #E60000
</style>
